import React from 'react';
import { Component } from "react";
import { API_URL } from '../urls';
import {Form} from "react-bootstrap";
import {Button} from "react-bootstrap";
import DefaultLayout from "../layouts/Default";
require('odatajs');

class EntityCreatePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      params: props.match.params
    };
  }

  componentDidMount() {
    document.title = "Create entity type";
  }

  save(e) {
    e.preventDefault();
    let token = localStorage.getItem('_TOKEN_AUTH');
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: "Bearer " + token };
    var request = {
        requestUri: API_URL + "Modules(" + this.state.params.project_id + ")/Types",
        method: 'POST',
        headers: headers,
        data: {
          "@odata.type":"#IVySoft.SiteBuilder.App.EntityType",
	  ...this.state.data
	}
    };
    window.odatajs.oData.request(
        request,
        (data, response) => {
          window.location.href = "/project/" + this.state.params.project_id; 
        },
        (err) => {
            alert('Fail: ' + err.message);
        }
    );    
  }

    render() { 
	return (
<DefaultLayout>
<Form onSubmit={(e) => this.save(e)}>
  <Form.Group>
    <Form.Label htmlFor="">Entity name</Form.Label>
    <Form.Control
      type="text" id="" placeholder="Enter entity type name" aria-describedby="HelpBlock"
      value={this.state.data.Name} onChange={(e) => { let data = this.state.data; data.Name = e.target.value; this.setState({ data });}}
    />
    <Form.Text id="HelpBlock" muted>Entity type name</Form.Text>
  </Form.Group>
<Button type="submit">Create entity type</Button>

</Form>
</DefaultLayout>
		);
    }
}
 
export default EntityCreatePage;